// outboxReducer.js
import {
  OUTBOX_FETCH_REQUEST,
  OUTBOX_FETCH_SUCCESS,
  OUTBOX_FETCH_FAILURE,
  OUTBOX_RETRY_REQUEST,
  OUTBOX_RETRY_SUCCESS,
  OUTBOX_RETRY_FAILURE,
  OUTBOX_SET_FILTERS,
  OUTBOX_SET_AUTO_REFRESH,
  OUTBOX_CLEAR_ERROR,
  OUTBOX_PREVIEW_REQUEST,
  OUTBOX_PREVIEW_SUCCESS,
  OUTBOX_PREVIEW_FAILURE,
  OUTBOX_CLEAR_PREVIEW,
} from "./outboxTypes";

const initialState = {
  messages: [],
  filteredMessages: [],
  filters: {
    status: "all",
    media: "all",
    dateRange: "all",
  },
  autoRefresh: true,
  isLoading: false,
  isRetrying: false,
  error: null,

  // Preview state
  previewMessage: null,
  isPreviewLoading: false,
  previewError: null,
};

const applyFilters = (messages, filters) => {
  let filtered = messages;

  if (filters.status !== "all") {
    filtered = filtered.filter((m) => m.status === filters.status);
  }

  if (filters.media !== "all") {
    filtered = filtered.filter((m) => m.media === filters.media);
  }

  return filtered;
};

const outboxReducer = (state = initialState, action) => {
  switch (action.type) {
    case OUTBOX_FETCH_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null,
      };

    case OUTBOX_FETCH_SUCCESS:
      return {
        ...state,
        messages: action.payload,
        filteredMessages: applyFilters(action.payload, state.filters),
        isLoading: false,
        error: null,
      };

    case OUTBOX_FETCH_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      };

    case OUTBOX_RETRY_REQUEST:
      return {
        ...state,
        isRetrying: true,
        error: null,
      };

    case OUTBOX_RETRY_SUCCESS:
      const updatedMessages = state.messages.map((message) => {
        if (message.id === action.payload) {
          return {
            ...message,
            status: "queued",
            retryCount: (message.retryCount || 0) + 1,
            error: undefined,
          };
        }
        return message;
      });

      return {
        ...state,
        messages: updatedMessages,
        filteredMessages: applyFilters(updatedMessages, state.filters),
        isRetrying: false,
        error: null,
      };

    case OUTBOX_RETRY_FAILURE:
      return {
        ...state,
        isRetrying: false,
        error: action.payload,
      };

    case OUTBOX_SET_FILTERS:
      const newFilters = { ...state.filters, ...action.payload };
      return {
        ...state,
        filters: newFilters,
        filteredMessages: applyFilters(state.messages, newFilters),
      };

    case OUTBOX_SET_AUTO_REFRESH:
      return {
        ...state,
        autoRefresh: action.payload,
      };

    case OUTBOX_CLEAR_ERROR:
      return {
        ...state,
        error: null,
      };

    // Preview actions
    case OUTBOX_PREVIEW_REQUEST:
      return {
        ...state,
        isPreviewLoading: true,
        previewError: null,
      };

    case OUTBOX_PREVIEW_SUCCESS:
      return {
        ...state,
        previewMessage: action.payload,
        isPreviewLoading: false,
        previewError: null,
      };

    case OUTBOX_PREVIEW_FAILURE:
      return {
        ...state,
        isPreviewLoading: false,
        previewError: action.payload,
      };

    case OUTBOX_CLEAR_PREVIEW:
      return {
        ...state,
        previewMessage: null,
        isPreviewLoading: false,
        previewError: null,
      };

    default:
      return state;
  }
};

export default outboxReducer;
